import React from "react";
import InputMask from "react-input-mask";
import Input from "./Input";

const MaskedInput = React.forwardRef((props, ref) => {
  const { mask, onChange, onBlur, ...restProps } = props;
  return (
    <InputMask mask={mask} onChange={onChange} onBlur={onBlur}>
      {(maskedInputProps) => (
        <Input {...restProps} {...maskedInputProps} ref={ref} />
      )}
    </InputMask>
  );
});

export default MaskedInput;
